import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import Scene from '../3D/Scene';
import Godrays from '../3D/Godrays';

// Bloc dedicat a godrays (2n render, underwater): només un .__target per ancorar-los. Overrides opcionals
// de posició via data-attributes del target (data-offset-x/y, data-rotation) → veure Godrays.
class ScrollItem__BlockGodrays extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        const target = this.item.querySelector('.__godray-target');
        if (target) {
            this._godrays = new Godrays(target);
            Scene.addGodrays(this._godrays);
        }
    }

    dispose() {
        if (this._godrays) { Scene.removeGodrays(this._godrays); this._godrays = null; }
        super.dispose();
    }
}

Scroll._registerClass('BlockGodrays', ScrollItem__BlockGodrays);

export default ScrollItem__BlockGodrays;
